/**
 * Userの状態管理をするクラス
 */
import { UserActions } from './actions';
import { userStatus, getStatus } from './status';
import { fetchFollowStatus } from './fetchFollowStatus';
import { fetchUserId } from './fetchUserId';

export class User {
  constructor (isLogined) {
    this.status = userStatus.notLogined;
    this.userId = 0;
    this.isLogined = isLogined;
    this.actions = new UserActions(this);
  }

  followCompany (companyId) {
    return this.actions.followCompany(companyId);
  }

  unfollowCompany (companyId) {
    return this.actions.unfollowCompany(companyId);
  }

  /**
   * ログイン時にユーザー情報を取得しインスタンスに保持させる
   *
   * @param {string} companyId 企業ID
   */
  updateUserInfo (companyId) {
    return Promise.all([
      fetchFollowStatus(companyId),
      fetchUserId()
    ]).then(([status, userId]) => {
      this.status = getStatus(this.isLogined, status);
      this.userId = userId;
    }).catch(([status, userId]) => {
      this.status = getStatus(this.isLogined, status);
      this.userId = userId;
    });
  }
}
